import { render, staticRenderFns } from "./EzFormModal.vue?vue&type=template&id=5501b4a9&scoped=true&"
import script from "./EzFormModal.vue?vue&type=script&lang=js&"
export * from "./EzFormModal.vue?vue&type=script&lang=js&"
import style0 from "./EzFormModal.vue?vue&type=style&index=0&id=5501b4a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5501b4a9",
  null
  
)

export default component.exports